<template>
  <div class="container">
    <div class="jumbotron">
      <h2 v-if="width > 990">Messages</h2>
      <div v-if="width > 990" class="row message-wrapper">
        <div class="col-3 left-col col-border">
          <div class="needs-padding">
            <h4 class="message-type"
                v-bind:class="{ 'active-message-type': activeType === 'all' }"
                v-on:click="activeType = 'all'">All</h4>
            <h4 class="message-type"
                v-bind:class="{ 'active-message-type': activeType === 'quoteRequests' }"
                v-on:click="activeType = 'quoteRequests'">Quote Requests</h4>
            <h4 class="message-type"
                v-bind:class="{ 'active-message-type': activeType === 'coupons' }"
                v-on:click="activeType = 'coupons'">Coupons</h4>
          </div>
        </div>
        <div v-if="activeType === 'quoteRequests'" class="col-4 col-border middle-col">
          <div v-on:click="activeThread = thread"
               class="thread-wrapper"
               v-for="(thread, index) in quoteRequests"
               v-bind:key="index"
               v-bind:class="{ active: activeThread.thread_id === thread.thread_id }">
            <div v-on:click="thread.number_unread = 0">
              <thread :name="thread.name"
                      :subject="thread.subject"
                      :messageDate="thread.latest_timestamp"
                      :numberUnread="activeThread.thread_id === thread.thread_id ? 0 : thread.number_unread"></thread>
            </div>
          </div>
        </div>
        <div v-if="activeType === 'coupons'" class="col-4 col-border middle-col">
          <div v-on:click="activeThread = thread"
               class="thread-wrapper"
               v-for="(thread, index) in coupons"
               v-bind:key="index"
               v-bind:class="{ active: activeThread.thread_id === thread.thread_id }">
            <div v-on:click="thread.number_unread = 0">
              <thread :name="thread.name"
                      :subject="thread.subject"
                      :messageDate="thread.latest_timestamp"
                      :numberUnread="activeThread.thread_id === thread.thread_id ? 0 : thread.number_unread"></thread>
            </div>
          </div>
        </div>
        <div v-if="activeType === 'all'" class="col-4 col-border middle-col">
          <div v-on:click="activeThread = thread"
               class="thread-wrapper"
               v-for="(thread, index) in threads"
               v-bind:key="index"
               v-bind:class="{ active: activeThread.thread_id === thread.thread_id }">
            <div v-on:click="thread.number_unread = 0">
              <thread :name="thread.name"
                      :subject="thread.subject"
                      :messageDate="thread.latest_timestamp"
                      :numberUnread="activeThread.thread_id === thread.thread_id ? 0 : thread.number_unread"></thread>
            </div>
          </div>
        </div>
        <div class="col-5 right-col col-border">
          <p v-if="!userIsBlocked" id="top-header" class="message-header"><i v-on:click="block" class="fa fa-window-close" aria-hidden="true"></i> <strong v-if="activeThread.name">{{ activeThread.name }}:</strong> {{ activeThread.subject }}</p>
          <p v-else id="top-header" class="message-header"><i v-on:click="unblock" class="fa fa-circle" aria-hidden="true"></i>{{ activeThread.name }} is blocked</p>
          <div id="middle-wrapper" v-if="activeThread.name" v-on:scroll="getMoreMessages">
            <div class="buffer"></div>
            <div class="row" v-for="(message, index) in messages" :key="index">
              <div v-if="getCognitoId === message.sender || getBusinessId === message.sender" class="col-9 offset-3">
                <p class="sender-text">{{ message.message}}</p>
              </div>
              <div v-else class="col-9">
                <p class="reciever-text">{{ message.message}}</p>
              </div>
            </div>
            <div class="buffer"></div>
          </div>
          <div class="input-group mb-3" id="bottom-submit">
            <input type="text"
                   v-model="messageText"
                   v-on:keydown.enter="sendMessage"
                   class="form-control message-box"
                   placeholder="Message"
                   aria-label="Message"
                   aria-describedby="basic-addon2">
            <div class="input-group-append">
              <span v-on:click="sendMessage"
                    class="input-group-text-border input-group-text submit-button"
                    id="basic-addon2"><a>Submit</a></span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="width <= 990" v-on:click="back">
        <i class="fas fa-arrow-left"></i>
        <h3 class="col-label-sm" v-if="currentCenter === 'categories'">Categories</h3>
        <h3 class="col-label-sm" v-if="currentCenter === 'threads'">Messages</h3>
      </div>
      <div v-if="width <= 990" class="row message-wrapper">
        <div class="col col-border categories-col-sm" v-if="currentCenter === 'categories'">
          <h4 class="message-type"
              v-on:click="selectCategory('all')">All</h4>
          <hr class="divider">
          <h4 class="message-type"
              v-on:click="selectCategory('quoteRequests')">Quote Requests</h4>
          <hr class="divider">
          <h4 class="message-type"
              v-on:click="selectCategory('coupons')">Coupons</h4>
          <hr class="divider">
        </div>
        <div v-if="activeType === 'quoteRequests' && currentCenter === 'threads'" class="col col-border middle-col-small">
          <div v-on:click="selectThread(thread)"
               class="thread-wrapper"
               v-for="(thread, index) in quoteRequests"
               v-bind:key="index">
            <div v-on:click="thread.number_unread = 0">
              <thread :name="thread.name"
                      :subject="thread.subject"
                      :messageDate="thread.latest_timestamp"
                      :numberUnread="activeThread.thread_id === thread.thread_id ? 0 : thread.number_unread"></thread>
            </div>
          </div>
        </div>
        <div v-if="activeType === 'coupons' && currentCenter === 'threads'" class="col col-border middle-col-small">
          <div v-on:click="selectThread(thread)"
               class="thread-wrapper"
               v-for="(thread, index) in coupons"
               v-bind:key="index">
            <div v-on:click="thread.number_unread = 0">
              <thread :name="thread.name"
                      :subject="thread.subject"
                      :messageDate="thread.latest_timestamp"
                      :numberUnread="activeThread.thread_id === thread.thread_id ? 0 : thread.number_unread"></thread>
            </div>
          </div>
        </div>
        <div v-if="activeType === 'all' && currentCenter === 'threads'" class="col col-border middle-col-small">
          <div v-on:click="selectThread(thread)"
               class="thread-wrapper"
               v-for="(thread, index) in threads"
               v-bind:key="index">
            <div v-on:click="thread.number_unread = 0">
              <thread :name="thread.name"
                      :subject="thread.subject"
                      :messageDate="thread.latest_timestamp"
                      :numberUnread="activeThread.thread_id === thread.thread_id ? 0 : thread.number_unread"></thread>
            </div>
          </div>
        </div>
        <div v-if="currentCenter === 'messages'" class="col right-col-small col-border">
          <p v-if="!userIsBlocked" id="top-header" class="message-header"><i v-on:click="block" class="fa fa-window-close" aria-hidden="true"></i> <strong v-if="activeThread.name">{{ activeThread.name }}:</strong> {{ activeThread.subject }}</p>
          <p v-else id="top-header" class="message-header"><i v-on:click="unblock" class="fa fa-circle" aria-hidden="true"></i>{{ activeThread.name }} is blocked</p>
          <div id="middle-wrapper" v-if="activeThread.name" v-on:scroll="getMoreMessages">
            <div class="buffer"></div>
            <div class="row" v-for="(message, index) in messages" :key="index">
              <div v-if="getCognitoId === message.sender || getBusinessId === message.sender" class="col-9 offset-3">
                <p class="sender-text">{{ message.message}}</p>
              </div>
              <div v-else class="col-9">
                <p class="reciever-text">{{ message.message}}</p>
              </div>
            </div>
            <div class="buffer"></div>
          </div>
          <div class="input-group mb-3" id="bottom-submit">
            <input type="text"
                   v-model="messageText"
                   v-on:keydown.enter="sendMessage"
                   class="form-control message-box"
                   placeholder="Message"
                   aria-label="Message"
                   aria-describedby="basic-addon2">
            <div class="input-group-append">
              <span v-on:click="sendMessage"
                    class="input-group-text submit-button"
                    id="basic-addon"><a>Submit</a></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Thread from './Thread.vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import router from '../../../../router/index.js'

export default {
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  async mounted () {
    this.mounted = true
    this.setConversationWrapperHeight()
    await this.getThreads()
    this.activeThread = this.threads[0] ? this.threads[0] : {}
    var that = this
    function update () {
      setTimeout(async function () {
        if (that.mounted) {
          that.getThread()
          that.getThreads()
          update()
        }
      }, 15000)
    }
    update()
  },
  beforeDestroy () {
    this.mounted = false
  },
  data () {
    return {
      width: null,
      activeType: 'all',
      activeThread: {},
      quoteRequests: [],
      coupons: [],
      archived: [],
      blocked: [],
      threads: [],
      messages: [],
      messageText: '',
      mounted: false,
      lastEvaluatedThreadKey: null,
      lastEvaluatedMessageKey: null,
      evaluateLastKey: true,
      currentCenter: 'threads'
    }
  },
  components: {
    Thread
  },
  computed: {
    ...mapGetters([
      'getCognitoId'
    ]),
    ...mapGetters('business', [
      'getBusinessId'
    ]),
    ...mapGetters('user', [
      'getUserType'
    ]),
    userIsBlocked () {
      var id
      if (this.messages.length === 0) return false
      if (this.getCognitoId === this.messages[0].sender || this.getBusinessId === this.messages[0].sender) {
        id = this.messages[0].recipients
      } else {
        id = this.messages[0].sender
      }
      if (this.getUserType === 'user') {
        return this.$store.getters['user/getBlockList'].includes(id)
      }
      if (this.getUserType === 'business') {
        return this.$store.getters['business/getBlockList'].includes(id)
      }
    }
  },
  methods: {
    ...mapActions('user', [
      'getNotifications'
    ]),
    ...mapActions('business', [
      'syncData'
    ]),
    ...mapMutations('user', {
      userAddToBlockList: 'addToBlockList',
      userRemoveFromBlockList: 'removeFromBlockList'
    }),
    ...mapMutations('business', {
      businessAddToBlockList: 'addToBlockList',
      businessRemoveFromBlockList: 'removeFromBlockList'
    }),
    selectCategory (category) {
      this.activeType = category
      this.currentCenter = 'threads'
    },
    selectThread (thread) {
      this.activeThread = thread
      this.currentCenter = 'messages'
      this.$nextTick(function () {
        this.setConversationWrapperHeight()
        this.manageScrollbar()
      })
    },
    back () {
      if (this.currentCenter === 'categories') {
        if (this.getUserType === 'user') {
          router.push('/profile/user/dashboard')
        }
        if (this.getUserType === 'business') {
          router.push('/profile/business/dashboard')
        }
      }
      if (this.currentCenter === 'threads') this.currentCenter = 'categories'
      if (this.currentCenter === 'messages') this.currentCenter = 'threads'
    },
    handleResize () {
      this.width = window.innerWidth
      this.setConversationWrapperHeight()
      this.manageScrollbar()
    },
    async block () {
      var idToBlock
      if (this.getCognitoId === this.messages[0].sender || this.getBusinessId === this.messages[0].sender) {
        idToBlock = this.messages[0].recipients
      } else {
        idToBlock = this.messages[0].sender
      }
      if (this.getUserType === 'user') this.userAddToBlockList(idToBlock)
      if (this.getUserType === 'business') this.businessAddToBlockList(idToBlock)
      await this.syncData()
    },
    async unblock () {
      var idToUnBlock
      if (this.getCognitoId === this.messages[0].sender || this.getBusinessId === this.messages[0].sender) {
        idToUnBlock = this.messages[0].recipients
      } else {
        idToUnBlock = this.messages[0].sender
      }
      if (this.getUserType === 'user') this.userRemoveFromBlockList(idToUnBlock)
      if (this.getUserType === 'business') this.businessRemoveFromBlockList(idToUnBlock)
      await this.syncData()
    },
    setConversationWrapperHeight () {
      var topHeight = document.getElementById('top-header')
      var bottomHeight = document.getElementById('bottom-submit')
      var middleWrapper = document.getElementById('middle-wrapper')
      if (middleWrapper) middleWrapper.style.height = (650 - topHeight.offsetHeight - bottomHeight.offsetHeight).toString() + 'px'
    },
    manageScrollbar () {
      var scrollSection = document.getElementById('middle-wrapper')
      if (scrollSection) {
        this.$nextTick(function () {
          scrollSection.scrollTop = scrollSection.scrollHeight
        })
      }
    },
    async sendMessage () {
      if (!this.messageText) return
      var messageText = this.messageText
      this.messageText = ''
      var client = this.$store.getters.getMessageApigClientFactory
      var params = { thread_id: this.activeThread.thread_id }
      var pathTemplate = '/messages/{thread_id}'
      var method = 'POST'
      var additionalParams = {}
      var sender = this.getUserType === 'user' ? this.getCognitoId : this.getBusinessId
      var recipients
      if (this.getCognitoId === this.messages[0].sender || this.getBusinessId === this.messages[0].sender) {
        recipients = this.messages[0].recipients
      } else {
        recipients = this.messages[0].sender
      }
      var body = {
        message: messageText,
        sender: sender,
        recipients: recipients
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.getThread()
      } catch (error) {
        console.log(error)
      }
    },
    async getThreads () {
      var client = this.$store.getters.getMessageApigClientFactory
      var params = {}
      var pathTemplate = '/messages'
      var method = 'GET'
      var additionalParams = {
        queryParams: {
          limit: 200
        }
      }
      if (this.getUserType === 'business') additionalParams.queryParams['requesting_as'] = this.getBusinessId
      var body = {}
      try {
        var threadData = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.lastEvaluatedThreadKey = threadData.data.last_evaluated_key
        if (threadData.data.data.length === 0) return
        this.threads = threadData.data.data.map((thread) => {
          var dateString = new Date(thread.latest_timestamp)
          thread.latest_timestamp = (dateString.getMonth() + 1).toString() + '/' + dateString.getDate().toString() + '/' + dateString.getFullYear().toString().slice(-2)
          return thread
        })
        this.quoteRequests = this.threads.filter((thread) => thread.category === 'Quote Request')
        this.blocked = this.threads.filter((thread) => thread.category === 'Blocked')
        this.archived = this.threads.filter((thread) => thread.category === 'Arvhived')
      } catch (error) {
        console.log(error)
      }
    },
    async getThread () {
      var client = this.$store.getters.getMessageApigClientFactory
      var params = { thread_id: this.activeThread.thread_id }
      var pathTemplate = '/messages/{thread_id}'
      var method = 'GET'
      var additionalParams = {
        queryParams: {
          limit: 25
        }
      }
      if (this.getUserType === 'business') additionalParams.queryParams['requesting_as'] = this.getBusinessId
      var body = {}
      try {
        var threadData = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        if (this.evaluateLastKey) this.lastEvaluatedMessageKey = threadData.data.last_evaluated_key
        this.evaluateLastKey = false
        var newMessages = await threadData.data.data.reverse()
        var oldMessages = this.messages.map(message => JSON.stringify(message))
        newMessages = newMessages.map(message => JSON.stringify(message))
          .filter(message => !oldMessages.includes(message))
          .map(message => JSON.parse(message))
        this.messages = this.messages.concat(newMessages)
        if (newMessages.length > 0) {
          this.$nextTick(this.manageScrollbar())
        }
        this.setConversationWrapperHeight()
        this.getNotifications()
      } catch (error) {
        console.log(error)
      }
    },
    async getMoreMessages () {
      var el = document.getElementById('middle-wrapper')
      if (el.scrollTop !== 0) return
      if (!this.lastEvaluatedMessageKey) return
      var client = this.$store.getters.getMessageApigClientFactory
      var params = { thread_id: this.activeThread.thread_id }
      var pathTemplate = '/messages/{thread_id}'
      var method = 'GET'
      var additionalParams = {
        queryParams: {
          limit: 25,
          last_evaluated_key: JSON.stringify(this.lastEvaluatedMessageKey)
        }
      }
      if (this.getUserType === 'business') additionalParams.queryParams['requesting_as'] = this.getBusinessId
      var body = {}
      try {
        var threadData = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.lastEvaluatedMessageKey = threadData.data.last_evaluated_key
        var newMessages = await threadData.data.data.reverse()
        this.messages = newMessages.concat(this.messages)
        this.setConversationWrapperHeight()
        this.getNotifications()
      } catch (error) {
        console.log(error)
      }
    }
  },
  watch: {
    activeThread: async function () {
      this.lastEvaluatedMessageKey = null
      this.messages = []
      this.evaluateLastKey = true
      await this.getThread()
      this.manageScrollbar()
    },
    activeType: function (newType) {
      if (newType === 'quoteRequests') this.activeThread = this.quoteRequests[0] ? this.quoteRequests[0] : {}
      if (newType === 'coupons') this.activeThread = this.coupons[0] ? this.coupons[0] : {}
      if (newType === 'all') this.activeThread = this.threads[0] ? this.threads[0] : {}
      if (newType === 'archived') this.activeThread = this.archived[0] ? this.archived[0] : {}
      if (newType === 'blocked') this.activeThread = this.blocked[0] ? this.blocked[0] : {}
    }
  }
}
</script>

<style scoped>
.col-label-sm {
  padding-left: 1rem;
}

.categories-col-sm {
  padding: 0;
}

.divider {
  border-width: 2px 0;
  border-color: #949494 !important;
  margin: 0;
}

.fa-arrow-left {
  font-size: 2rem;
  padding-bottom: 5px;
  cursor: pointer;
  margin-left: .7rem;
  color: #4f4f4f !important;
}

.col-9 {
  word-wrap: break-word !important;
}

.message-type {
  padding: .5rem;
  margin: 0 !important;
  cursor: pointer;
}

.active-message-type {
  color: white !important;
  border-radius: 10px;
  background-color: orange;
}

.buffer {
  padding: .1rem;
}

input[type="text"], textarea {
  outline: none;
  box-shadow:none !important;
  border:1px solid #ccc !important;
}

.submit-button {
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #748096;
  color: white;
}

.submit-button:active {
  background-color: gray;
}

.message-header {
  margin-bottom: 0px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: .5rem;
  padding-bottom: .5rem;
  border-bottom-style: solid;
  border-width: 2px;
  border-color: #949494 !important;
}

.sender-text {
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-word;
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
  background-color: orange;
  padding-right: 1rem;
  padding-left: 1rem;
  padding-top: .5rem;
  padding-bottom: .5rem;
  margin-bottom: .2rem;
  margin-right: .6rem;
  color: white !important;
  border-radius: 10px;
}

.reciever-text {
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  word-break: break-word;
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
  background-color: #f1f1f1;
  padding-right: 1rem;
  padding-left: 1rem;
  padding-top: .5rem;
  padding-bottom: .5rem;
  border-radius: 10px;
  margin-bottom: .2rem;
  margin-left: .4rem;
}

.active {
  background-color: #f1f1f1;
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-top: 3rem;
}

.no-margin {
  margin-bottom: 0;
}

.thread-wrapper {
  cursor: pointer;
  border-bottom-style: solid;
  border-width: 2px;
  border-color: #949494 !important;
}

.needs-padding {
  padding: .5rem;
}

.left-col {
  border-radius: 15px 0px 0px 15px !important;
}

.form-control {
    border-radius: 0px 0px 0px 0px !important;
}

#middle-wrapper {
  overflow-y: scroll;
  overflow-x: hidden;
}

.middle-col {
  border-right-style: none !important;
  border-left-style: none !important;
  padding-right: 0;
  padding-left: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}

.middle-col-small {
  padding-right: 0;
  padding-left: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}

.right-col {
  border-radius: 0px 15px 15px 0px;
}

.input-group-text-border {
  border-radius: 0px 0px 15px 0px;
}

.right-col {
  padding-right: 0;
  padding-left: 0;
}

.right-col-small {
  padding-right: 0;
  padding-left: 0;
}

.input-group {
  position: absolute;
  bottom: 0;
  margin-bottom: 0 !important;
}

.col-border {
  background-color: white;
  border-style: solid;
  border-width: 2px;
  border-color: #949494 !important;
}

.message-wrapper, .col-border {
  height: 650px !important;
}

.fa {
  margin-right: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/shared/messaging/Messaging.vue